var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 16,
    viewBox: "0 -960 960 960",
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M394.804-194.5q-99.152 0-170.326-64.674Q153.304-323.848 153.304-420q0-96.152 71.174-160.826Q295.652-645.5 394.804-645.5h238.848l-98.5-98.5 63.652-63.652L806.696-600 598.804-392.348 535.152-456l98.5-98.5H394.804q-60.847 0-105.674 38.326-44.826 38.326-44.826 96.174 0 57.848 44.826 96.174Q333.957-285.5 394.804-285.5h289.5v91h-289.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.4416d41e99fd327238f97cd8091b7440.svg";
export { ForwardRef as ReactComponent };